import constants from "../constants";

const { CONTAINER_LAYOUTS, CONTENT_ITEM_TYPES } = constants;

/**
 * Method to get item id for adding/removing a favourite
 * @param {Object} item favourite item to added or removed
 * @param {Boolean} isSportSeries
 * @returns {String} id of the item to be added or removed
 */
export const getFavouriteItemId = (item, isSportSeries = false) => {
  const { layout, metadata } = item;
  if (layout?.toLowerCase() === CONTAINER_LAYOUTS.CONTENT_ITEM) {
    const { uaGroupId, uaId } = metadata?.extendedMetadata?.dlum || {};
    return metadata?.extendedMetadata?.dlum?.uaGroupType?.toLowerCase() === CONTENT_ITEM_TYPES.tvshow
      ? uaGroupId
      : uaId;
  }
  return isSportSeries ? metadata.seriesUaId : item.id;
};
